import { useContainer } from "#imports";
import { DependencyInjectId } from "@@/package/const/DependencyInjectId";
import type SurveyMapper from "~~/package/mapper/survey/SurveyMapper";
import { type SurveyResponseModel } from "~~/package/mapper/survey/model/SurveyResponseModel";
import { type SurveyCompletionModel } from "~~/package/mapper/survey/model/SurveyCompletionModel";

export const useSurveyService = () => {
    const surveyMapper = useContainer<SurveyMapper>(DependencyInjectId.SurveyMapper);

    const submitResponse = (request: SurveyResponseModel): Promise<boolean> => {
        return surveyMapper.submitResponse(request);
    };

    const fetchCompletions = (): Promise<SurveyCompletionModel[]> => {
        return surveyMapper.fetchCompletions();
    };

    return {
        submitResponse,
        fetchCompletions
    };
};
